import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { functions } from '../../config/firebase';
import { httpsCallable } from 'firebase/functions';
import { ClipLoader } from 'react-spinners';
import './supportDataDeletion.css'; // Reuse styles

const ConfirmDeletion = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const [status, setStatus] = useState('verifying'); // verifying, success, error
    const [message, setMessage] = useState('');

    useEffect(() => {
        const verifyToken = async () => {
            if (!token) {
                setStatus('error');
                setMessage('Invalid confirmation link. Token is missing.');
                return;
            }

            try {
                const confirmDeletionFn = httpsCallable(functions, 'confirmDeletion');
                const result = await confirmDeletionFn({ token });

                if (result.data.success) {
                    setStatus('success');
                    setMessage(result.data.message);
                } else {
                    setStatus('error');
                    setMessage(result.data.message || 'Deletion failed.');
                }
            } catch (err) {
                console.error("Confirmation error:", err);
                setStatus('error');
                setMessage(err.message || 'An error occurred during account deletion.');
            }
        };

        verifyToken();
    }, [token]);

    return (
        <div className='main support-deletion-page'>
            <a href="https://flintt.me/"><div className='nav-logo'></div></a>

            <div className="support-deletion">
                <div className="deletion-section" >
                    <h2>Account Deletion Confirmation</h2>

                    {status === 'verifying' && (
                        <div style={{ padding: '40px', textAlign: 'center' }}>
                            <ClipLoader size={50} color="#fff" />
                            <p style={{ marginTop: '20px' }}>Verifying your request...</p>
                        </div>
                    )}

                    {status === 'success' && (
                        <div className="success-message" style={{ color: '#155724', padding: '20px', borderRadius: '8px' }}>
                            <h3>Account Deleted</h3>
                            <p>{message}</p>
                            <p>We are sorry to see you go. Your data has been securely wiped.</p>
                        </div>
                    )}

                    {status === 'error' && (
                        <div className="error-message" style={{color: '#721c24', padding: '20px', borderRadius: '8px' }}>
                            <h3>Deletion Failed</h3>
                            <p>{message}</p>
                            <p>Please request deletion again from the <Link to="/data-deletion">Data Deletion Page</Link>.</p>
                        </div>
                    )}

                    <div style={{ marginTop: '30px' }}>
                        <Link to="/" style={{ color: '#fbead3', textDecoration: 'underline' }}>Return to Home</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfirmDeletion;
